import { useEffect, useState } from "react";
import { FontScreen } from "./fontScreen";
import { NameScreen } from "./nameScreen";
import { PhoneScreen } from "./phoneScreen";
import { EmailScreen } from "./emailScreen";
import { PasswordScreen } from "./passwordScreen";
import { webRegister } from "../../api/user";
import { IUser } from "../../type";
import { useNavigate } from "react-router-dom";
import { subscribeForPush } from "../../utils/pushSubscription";
import { ensureClientFingerprint, setClientLoginHint } from "../../utils/clientIdentity";

interface IUserTMP {
  name?: string;
  phone?: string;
  email?: string;
}

interface IProps {
  setUser: (v: IUser) => void;
  onRegistrationSuccess?: (user: IUser) => void;
}

export function Registration(props: IProps) {
  const [user, setUser] = useState<IUserTMP>({});
  const [page, setPage] = useState<number>(0);
  const [username, setUsername] = useState<string>("");
  const navigate = useNavigate();
  const [passwordError, setPasswordError] = useState<string>("");

  useEffect(() => {
    ensureClientFingerprint();
  }, []);

  const onclick = () => {
    setPage(page + 1);
  };
  const onclick1 = (n: string) => {
    setPage(page + 1);
    setUser({ ...user, name: n });
    setUsername(n);
  };
  const onclick2 = (ph: string) => {
    setPage(page + 1);
    setUser({ ...user, phone: ph });
  };
  const onclick3 = (e: string) => {
    // Сохраняем email в состоянии, чтобы на финальном шаге (set password)
    // корректно передать его в backend.
    setUser({ ...user, email: e });
    setClientLoginHint(e);
    setPage(page + 1);
  };

  const onPasswordSubmit = async (password: string, confirmPassword: string) => {
    setPasswordError("");
    if (password !== confirmPassword) {
      setPasswordError("Пароли не совпадают.");
      return;
    }
    const email = user.email;
    if (!email) {
      setPasswordError("Email не найден. Повторите регистрацию.");
      return;
    }

    setClientLoginHint(email);
    const r = await webRegister({
      name: user.name || "",
      phone: user.phone || "",
      email,
      password,
      confirmPassword,
    });

    if (r.type === "success" && r.user) {
      if (props.onRegistrationSuccess) props.onRegistrationSuccess(r.user);
      else props.setUser(r.user);
      subscribeForPush("web");
      navigate("/");
    } else {
      if (r.type === "error") {
        setPasswordError(r.message || "Не удалось сохранить пароль");
      } else {
        setPasswordError("Не удалось сохранить пароль");
      }
    }
  };

  return (
    <section className="section mainPage flex flex-column registrationPage">
      <div className="progressBar">
        {[0, 1, 2, 3, 4].map((p, index) => {
          let cls = "";
          if (index <= page) {
            cls = "active";
          }
          return <div className={cls} key={index} />;
        })}
      </div>
      {page === 0 ? (
        <FontScreen onclkbtn={onclick} />
      ) : page === 1 ? (
        <NameScreen onclkbtn={onclick1} />
      ) : page === 2 ? (
        <PhoneScreen onclkbtn={onclick2} />
      ) : page === 3 ? (
        <EmailScreen onclkbtn={onclick3} />
      ) : page === 4 ? (
        <PasswordScreen
          name={username}
          error={passwordError}
          onSubmit={onPasswordSubmit}
        />
      ) : (
        ""
      )}
    </section>
  );
}
